import { ChartTypeConfig } from './ChartTypeConfig';
import { SeriesType } from '../utils/SeriesType';
import { BasicChart, SeriesOption } from '../utils/models';

export class ScatterChartConfig implements ChartTypeConfig {
  getConfig(categories: string[], data: SeriesOption[], colors: string[]): Partial<BasicChart> {
    return {
      xAxis: { type: 'category', data: categories },
      yAxis: { type: 'value' },
      series: [{
        type: SeriesType.Scatter,
        data
      }]
    };
  }
}
